<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_common_user'
      params>
      <div>
        <span class='left-table'>手机号码：</span>
        <el-input v-model='phone' placeholder='请输入手机号码' style='width: 200px;'></el-input>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>
        <!--        <span class="left-table">-->
        <!--          <el-button type="success" icon="el-icon-circle-plus" @click="showAdd">增加</el-button>-->
        <!--        </span>-->
      </div>

    </icare-table>
<!--    &lt;!&ndash; 编辑信息 &ndash;&gt;-->
<!--    <el-dialog title='编辑信息' :visible.sync='editVisible' width='50%'>-->
<!--      <el-form :model='form' label-width='200px'>-->

<!--        &lt;!&ndash;        <el-form-item :disabled='true' label="代理商ID" :label-width="formLabelWidth">&ndash;&gt;-->
<!--        &lt;!&ndash;          <el-input v-model="form.agency_id" disabled  placeholder="请输入代理商ID"></el-input>&ndash;&gt;-->
<!--        &lt;!&ndash;        </el-form-item>&ndash;&gt;-->

<!--        <el-form-item label='站点名称' :label-width='formLabelWidth'>-->
<!--          <el-input v-model='form.work_group_name'></el-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item label='收费类型' :label-width='formLabelWidth'>-->
<!--          <el-select v-model='form.charge_type_id' placeholder='请选择'>-->
<!--            <el-option-->
<!--              v-for='item in time_standard_options'-->
<!--              :key='item.id'-->
<!--              :label='item.time_standard_name'-->
<!--              :value='item.id'>-->
<!--            </el-option>-->
<!--          </el-select>-->

<!--        </el-form-item>-->

<!--        <el-form-item label='基础电费' :label-width='formLabelWidth'>-->
<!--          <el-input-number v-model='form.base_energy_charge' precision='2' controls-position='right' :min='1'-->
<!--                           :max='10'></el-input-number>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <div slot='footer' class='dialog-footer'>-->
<!--        <el-button @click='closeDialog'>取 消</el-button>-->
<!--        <el-button type='primary' @click='save'>确 定</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'

export default {
  data() {
    return {
      loading: false,
      tableParams: {
        phone: null
      },
      phone:null,
      titleConfig: [
        {
          field: 'phone',
          title: '手机号码',
          visible: true
        },
        {
          field: 'nick_name',
          title: '用户昵称',
          visible: true
        },
        {
          field: 'avatar_url',
          title: '用户头像',
          visible: true,
          isPic:true
        },
        {
          field: 'balance',
          title: '用户余额',
          visible: true,
          fuc: val => {
            return (val / 100).toFixed(2) + ' 元'
          }
        },

        {
          field: 'create_time',
          title: '创建时间',
          visible: true
        },
        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            // {
            //   title: '编辑',
            //   icon: 'edit',
            //   fuc: this.showEdit
            // },
            {
              title: '删除',
              color: '#F56C6C',
              icon: 'el-icon-delete',
              fuc: this.delete
            }
          ]
        }
      ],
      form: {
        id: ''
      },
      formLabelWidth: '100px',
      editVisible: false,
      dialogType: 0
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {

  },
  methods: {

    //弹出编辑(新增)对话框
    showEdit(row) {
      this.dialogType = 2
      this.editVisible = true
      this.form = Object.assign({}, row)
    },
    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.dialogType = 0
      this.form = {}
    },
    //模糊搜索
    find() {
      this.tableParams.phone = this.phone
      this.$refs.table.refresh()
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.phone + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'other_remove_common_user',
          params: str
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },

    // save() {
    //   let func = ''
    //   if (this.dialogType === 2) {
    //     func = ''
    //   }
    //   let str = JSON.stringify(this.form)
    //   gateway({
    //     func: func,
    //     params: str
    //   }).then(() => {
    //     this.closeDialog()
    //     this.$refs.table.refresh()
    //   })
    // }


  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

</style>
